@for (opmerking of opmerkingen(); track opmerking.id) {
	<div class="opmerking" [appTooltip]="(opmerking.tijdstip | date: 'medium') ?? ''">
		<span class="auteur">{{ opmerking.auteur }}:</span>
		<span class="tekst" [innerHTML]="markdown.parseInline(opmerking.tekst)"></span>
		@if (opmerking.eigen) {
			<span class="acties">
				<button class="icon" appTooltip="Notitie bewerken" (click)="wijzigen.emit(opmerking)">
					<app-icon name="edit" size="small" color="typography-5" hoverColor="typography-3"></app-icon>
				</button>
				<button class="icon" appTooltip="Notitie verwijderen" (click)="verwijderen.emit(opmerking)">
					<app-icon name="delete" size="small" color="typography-5" hoverColor="error-1"></app-icon>
				</button>
			</span>
		}
	</div>
}
